import { XYGraph } from "@certn/cascadia-react";
import { useContext } from "react";

import { CascadiaJsonFormContext } from "../CascadiaJsonFormContext";
import {
  CascadiaControlProps,
  withCascadiaControlProps,
} from "../wrappers/withCascadiaControlProps";

export function XYGraphControl(props: CascadiaControlProps) {
  const { options } = props;
  const { isSummary } = useContext(CascadiaJsonFormContext);

  if (isSummary) {
    return null;
  }

  return (
    <XYGraph
      data={options.data_override || props.data}
      prefix={options.prefix}
      testId={options?.chart_name}
      chartTitle={options?.chart_title}
    />
  );
}

XYGraphControl.displayName = "ChartControl";

export const XYGraphRenderer = withCascadiaControlProps(XYGraphControl);
